/**
 * Created by commyfeng on 2017/3/21.
 */

import _Coa from "./lib/Coa";
import toFactory from "./lib/toFactory";
import middlewareFunc from "./middleware";
import extendFunc from "./extend";
var Coa = toFactory(_Coa);
middlewareFunc(Coa);
extendFunc(Coa);
Coa.RequestError = require("./lib/RequestError");
Coa.RequestErrorType = require("./lib/RequestErrorType");
export default Coa;